<script setup>
import {computed, defineProps} from 'vue';
import useUtils from '../../Composables/useUtils';
import useLote from '../../Composables/useLote';
import useGlobals from '../../Composables/useGlobals';
import useLoteLocalComUpdates from '../../Composables/useLoteLocalComUpdates';
import useLeilaoLocalComUpdates from '../../Composables/useLeilaoLocalComUpdates';

const props = defineProps({
    leilaoInit: Object,
    loteInit: Object,
    mostrarLeilao: Boolean,
});

const {
    lote
} = useLoteLocalComUpdates(props)

const {
    leilao
} = useLeilaoLocalComUpdates(props)

const {
    getImagem,
    formatDateWithoutSeconds,
    formatador,
    formatadorLote,
    stripHTML,
} = useUtils();

const {
    fullscreen,
    autoplay,
    slide,
    abrirLoteArrematado
} = useLote(leilao, lote)

const {
    logoLeiloeiro
} = useGlobals();


function capitalizeWords(str) {
    return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)).join(' ');
}

const valorComissao = computed(() => +lote?.value.lanceAtual * +(leilao.value.porcentagem_comissao || 5)/ 100);

function valorTaxa(arrayTaxa){

    if(+arrayTaxa?.taxa?.variavel === 0){

        return (+arrayTaxa?.taxa.tipo_taxa === 2) ? (+lote?.value.lanceAtual * +arrayTaxa?.valor) / 100 : +arrayTaxa?.valor;

    }else{

        if(!arrayTaxa.taxa.taxa_faixa_variavel || arrayTaxa.taxa.taxa_faixa_variavel.length === 0) {
            return (+arrayTaxa?.taxa.tipo_taxa === 2) ? (+lote?.value.lanceAtual * +arrayTaxa?.valor) / 100 : +arrayTaxa?.valor;

        }else{
            const valorArredondado = Math.floor(+lote?.value.lanceAtual);

            const faixa = arrayTaxa?.taxa?.taxa_faixa_variavel.find((f) => {
                const lanceMinimo = +f.faixa_valor_minimo;
                const lanceMaximo = (f.faixa_valor_maximo) ? +f.faixa_valor_maximo : 99999999999999;
                return (+valorArredondado >= lanceMinimo && +valorArredondado <= lanceMaximo);
            });

            if(faixa){
                return (+arrayTaxa?.taxa.tipo_taxa === 2) ? (+lote?.value.lanceAtual * +faixa.valor) / 100 : +faixa.valor;
            }else{
                return (+arrayTaxa?.taxa.tipo_taxa === 2) ? (+lote?.value.lanceAtual * +arrayTaxa?.valor) / 100 : +arrayTaxa?.valor;
            }

        }

    }

}

const valorTotalComDespesas = computed(() => {
    let somaValorDespesas = 0;
    if(lote?.value.taxas_lote) {

        somaValorDespesas = lote?.value.taxas_lote.reduce((acc, e) => {
            let valor = valorTaxa(e);

            return acc + valor;
        }, 0);

    }

    // return +props.valorLance + valorComissao.value + +somaValorDespesas;
    return +lote?.value.lanceAtual + valorComissao.value + +somaValorDespesas;

});

</script>

<template>

   <div class="q-pa-sm col col-12"
         style="justify-content: stretch"
    >
        <q-card class="cursor-pointer" :style="$q.screen.lt.sm ? 'width:100%' : ''">

            <q-card-section
            :horizontal="$q.screen.gt.sm"
            :style="`background-color: ${lote.status_lote?.cor_site};`"
            class="
                  text-subtitle1
                  text-white
                  text-center
                  q-py-none
                  column
                  justify-center
            "
            style="height: 2em;"
            @click="abrirLoteArrematado()" >

                {{lote.status_lote?.nome}}

        </q-card-section>

            <q-card-section :horizontal="$q.screen.gt.sm" class="q-pa-none">

                <q-card-section :style="$q.screen.gt.sm ? 'min-width: 550px' : ''" class="q-pa-none">

                    <q-responsive
                        :ratio="16/9" style="width: 100%;"
                    >
                        <q-carousel
                            v-model="slide"
                            v-model:fullscreen="fullscreen"
                            :autoplay="autoplay"
                            :thumbnails="fullscreen"
                            animated
                            arrows
                            control-color="white"
                            control-text-color="primary"
                            control-type="push"
                            next-icon="mdi-chevron-right"
                            prev-icon="mdi-chevron-left"
                            height="14em"
                            infinite
                            swipeable
                        >
                            <template v-slot:control>
                                <q-carousel-control
                                    :offset="[10, 10]"
                                    position="top-right"
                                >
                                    <q-btn
                                        :icon="fullscreen ? 'mdi-arrow-u-left-top' : 'mdi-fullscreen'" color="white" push
                                        text-color="primary"
                                        @click.stop="fullscreen = !fullscreen"
                                    >{{ fullscreen ? 'Voltar' : '' }}
                                    </q-btn>
                                </q-carousel-control>
                                <q-carousel-control
                                    :offset="[10, 10]"
                                    position="bottom-left"
                                    v-if="+lote.vistoria_imobiliaria?.desocupado"
                                >
                                    <q-badge size="sm" color="primary" rounded>
                                        <q-icon name="mdi-home-export-outline" size="xs" class="q-mr-xs"/> Desocupado
                                    </q-badge>
                                </q-carousel-control>
                                <q-carousel-control
                                    :offset="[10, 10]"
                                    position="bottom-left"
                                    v-if="+lote.vistoria_veicular?.sucata"
                                >
                                    <q-badge size="sm" color="primary" rounded>
                                        <q-icon name="mdi-car-wrench" size="xs" class="q-mr-xs"/> Sucata
                                    </q-badge>
                                </q-carousel-control>
                            </template>
                            <q-carousel-slide
                                v-for="(imagem, key) in (lote.imagens_lote && lote.imagens_lote.length > 0  ? lote.imagens_lote
                : (leilao.comitente.arquivo_capa_padrao ? [{arquivo: leilao.comitente.arquivo_capa_padrao}] : []))"
                                :key="key"
                                :name="1+key"
                                style="background-position: center;background-size: contain;background-repeat: no-repeat"
                                @click="abrirLoteArrematado()"
                                class="q-pa-none">
                                <q-img
                                    class="full-width full-height"
                                    loading="lazy"
                                    :src="getImagem(imagem?.arquivo, fullscreen, leilao.status_leilao?.identificador)"
                                    :ratio="16/9"
                                >
                                    <template v-slot:error>
                                        <div class="absolute-full flex flex-center bg-primary text-white">
                                            Houve um problema carregando a imagem
                                        </div>
                                    </template>
                                    <template v-slot:loading>
                                        <div class="absolute-full flex column flex-center bg-white text-primary">
                                            <img :src="logoLeiloeiro" style="width: 40%" />
                                            <p class="q-mt-sm">
                                                <q-spinner size="sm" class="q-pr-sm" /> Carregando imagem...
                                            </p>
                                        </div>
                                    </template>
                                </q-img>
                                <div v-if="fullscreen" class="absolute-bottom custom-caption q-pb-xl">
                                    <q-card class="q-ma-lg q-ma-md-xl q-pa-md" style="overflow-y: scroll;max-height: 15vh;">
                                        <div class="text-h5">{{ lote.titulo }}</div>
                                        <div class="text-subtitle2" v-html="lote.descricao"></div>
                                    </q-card>
                                </div>
                                <div v-else class="absolute-bottom seq-caption q-pb-xl">
                                    <h5>
                                        Leilão {{ leilao.id }} - Lote {{formatadorLote(lote.sequencia)}}


                                    </h5>
                                </div>
                            </q-carousel-slide>
                        </q-carousel>
                    </q-responsive>

                </q-card-section>

                <q-card-section vertical style="width: 100%;">

                    <q-card-section
                        :class=" $q.dark.isActive ? 'bg-black' : 'bg-white'"
                        class="q-py-xs"
                        @click="abrirLoteArrematado()"
                    >
                        <div class="row no-wrap items-center"
                             @click="abrirLoteArrematado()" >
                            <div class="col desc-scroll text-h6" style="max-width: 100vw">
                                <p class="q-mb-none" style="line-height: 1.5em; height: 3em; overflow: hidden">Lote {{formatadorLote(lote.sequencia)}} - {{stripHTML(lote.titulo)}}</p>
                                <q-tooltip>
                                    Lote {{formatadorLote(lote.sequencia)}} - {{formatadorLote(lote.sequencia)}} {{stripHTML(lote.titulo)}}
                                </q-tooltip>
                            </div>
                        </div>

                    </q-card-section>

                    <q-separator/>

                    <q-list>

                        <q-item
                            :class=" $q.dark.isActive ? 'bg-black' : 'bg-white'"
                            clickable
                            @click="abrirLoteArrematado()"
                        >
                            <q-item-section avatar class="items-center">
                                <q-icon size="sm" color="primary" name="mdi-gavel"/>
                            </q-item-section>

                            <q-item-section class="text-body2" style="min-height: 55px;">
                                <q-item-label overline>Número do Leilão</q-item-label>
                                <q-item-label  class="text-primary">
                                    Leilão {{ leilao.id }} - {{ leilao.titulo}}
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                        <q-item
                            :class=" $q.dark.isActive ? 'bg-black' : 'bg-white'"
                            clickable
                            @click="abrirLoteArrematado()"
                        >
                            <q-item-section avatar class="items-center">
                                <q-icon size="sm" color="primary" name="mdi-calendar"/>
                                <q-icon size="sm" color="positive" name="mdi-currency-usd"/>
                            </q-item-section>

                            <q-item-section class="text-body2" >
                                <q-item-label>Data Leilão -
                                    <template v-if="+leilao.dois_leiloes === 0">
                                        {{ formatDateWithoutSeconds(leilao.data_hora_inicio) }}
                                    </template>
                                    <template v-if="+leilao.dois_leiloes === 1 && +leilao.primeiro_leilao_concluido === 1">
                                        {{ formatDateWithoutSeconds(leilao.data_hora_inicio_segundo_leilao) }}
                                    </template>
                                </q-item-label>
<!--                                <q-item-label class="text-body2 text-grey-8" >-->
<!--                                    <template v-if="+lote.lance_inicial > 0">-->
<!--                                        Valor Arrematado: {{ formatador.format(lote.lanceAtual) }}-->
<!--                                    </template>-->
<!--                                </q-item-label>-->
                                <q-item-label class="text-body2 text-grey-8" >
                                    <template v-if="+lote.lance_inicial > 0">


                                        Lance: {{ formatador.format(lote.lanceAtual) }} + Comissão Leiloeiro ({{leilao.porcentagem_comissao||5}}%): {{ formatador.format(valorComissao) }}
                                            <template v-for="taxa in lote?.taxas_lote" :key="taxa.id_taxa">
                                                + {{capitalizeWords(taxa?.taxa?.titulo)}}
                                                <template v-if="+valorTaxa(taxa) > 0">
                                                    : {{ formatador.format(valorTaxa(taxa)) }}
                                                </template>
                                            </template>
                                    </template>
                                </q-item-label>
                                <q-item-label class="text-body2 text-grey-8" >
                                    <template v-if="+lote.lance_inicial > 0">
                                        Valor total a pagar: {{ formatador.format(valorTotalComDespesas) }}
                                    </template>
                                </q-item-label>

                            </q-item-section>
                        </q-item>
                        <q-item
                            :class=" $q.dark.isActive ? 'bg-black' : 'bg-white'"
                            clickable
                            v-if="leilao.dois_leiloes === '1'"
                            @click="abrirLoteArrematado()"
                        >
                            <q-item-section avatar class="items-center">
                                <q-icon size="sm" color="primary" name="mdi-calendar"/>
                                <q-icon size="sm" color="positive" name="mdi-currency-usd"/>
                            </q-item-section>

                            <q-item-section class="text-body2" style="min-height: 55px;">
                                <q-item-label :style="+leilao.segundo_leilao_concluido === 1 ? 'text-decoration: line-through' : ''">2º Leilão - {{ formatDateWithoutSeconds(leilao.data_hora_inicio_segundo_leilao) }}</q-item-label>
                                <q-item-label class="text-body2 text-grey-8">
                                    <template v-if="+lote.lance_inicial_segundo_leilao > 0">
                                        Lance inicial: {{ formatador.format(lote.lance_inicial_segundo_leilao) }}
                                    </template>
                                    <template v-else>Entre e confira.</template>
                                </q-item-label>
                            </q-item-section>
                        </q-item>

                    </q-list>

                    <q-separator/>

                    <q-card-actions
                        style="height: 65px;"
                        :class=" $q.dark.isActive ? 'bg-black' : 'bg-white'"
                        class="flex column justify-center items-center"
                    >
                        <q-btn
                            color="primary"
                            flat
                            icon="mdi-package-variant"
                            ripple
                            size="md"
                            stretch
                            @click="abrirLoteArrematado()"
                            style="width: 100%; height: 100%"
                        >
                            Detalhes do Arremate
                            <q-tooltip>
                                Clique aqui para ver os detalhes do Arremate
                            </q-tooltip>
                        </q-btn>
                    </q-card-actions>

                </q-card-section>

            </q-card-section>

        </q-card>
    </div>

</template>
<style lang="sass" scoped>
.seq-caption
    text-align: center
    padding: 8px
    color: white
    background-color: rgba(0, 0, 0, .3)
.seq-caption > h5
    margin: 0
.desc-scroll::-webkit-scrollbar
    display: none
</style>
<style>
.cssmarquee {
    overflow: hidden;
    position: relative;
    height: 35px;
}
.cssmarquee p {
    margin: 0;
    padding: 0;
    position: absolute;
    height: 100%;
    text-align: center;
    overflow-x: visible;
    transform:translateX(0%);
    animation: cssmarquee 60s linear infinite;
}
@keyframes cssmarquee {
    0% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(-100%);
    }
}
</style>
